<div class="inner-container grid-gap-15 align-items-center w-full" *ngIf="call">
  <div class="call-container flex-grow-1" *ngIf="call.callerInfo">
    <div class="caller-name">{{ call.callerInfo.name }}</div>
    <div class="call-status">
      <img
        class="telephone-icon-sm"
        [pTooltip]="call.callStateText"
        tooltipPosition="left"
        [src]="call.callStateIcon"
      />
      {{ getCallStatusText(call) }}
    </div>
  </div>
  <div class="date-label flex-shrink-1 white-space-nowrap">
    {{ call.latestEvent?.date_started | datex : 'dddd Do MMMM YYYY' }}
  </div>
  <div class="date-label flex-shrink-1 white-space-nowrap">
    {{ call.latestEvent?.date_started | datex : 'HH:mm a' }}
  </div>
</div>
